var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1,.cls-2{fill:none;stroke:#292566;stroke-linecap:round;stroke-miterlimit:10;}.cls-1{stroke-width:2.05px;}.cls-2{stroke-width:2.1px;}")),React.createElement("line",{"className":"cls-1","x1":"9.74","y1":"9.79","x2":"20.21","y2":"20.26","key":1}),React.createElement("line",{"className":"cls-2","x1":"9.79","y1":"20.21","x2":"20.26","y2":"9.74","key":2})]);
}

Close.defaultProps = {"viewBox":"0 0 30 30"};

module.exports = Close;

Close.default = Close;
